import $axios from "@/service/httpServer";

import { baseUrl } from "./oldNew";
// 我的推荐信息
export const getRecommendInfo = (p) =>
  $axios.get(
    `${baseUrl}/marketing/recommend/miniProgram/getDetailsByUserId?type=${p.type}`
  );

// 推荐信息列表
// export const getRecommendList = (p) =>
//   $axios.get(`${baseUrl}/marketing/recommend/miniProgram/recommendList`, p);
export const getRecommendList = (p) =>
  $axios.get(`${baseUrl}/marketing/recommend/App/recommendList`, p);

// 获取城市列表
export const getCityList = (p) =>
  $axios.get(`${baseUrl}/marketing/recommend/getCityList`, p);

// 获取项目列表
export const getProjList = (p) =>
  $axios.get(`${baseUrl}/customer/oDBroker/findProjByCityCode`, p);
// 获取项目列表
// export const getProjList = (p) =>
//   $axios.get(`${baseUrl}/marketing/recommend/getProjectList`, p);

// 保存推荐信息
export const setSaveInfo = (p) =>
  $axios.post(
    `${baseUrl}/marketing/recommend/miniProgram/save?type=${p.type}&flag=${p.flag}`,
    p
  );

// 获取置业顾问列表
export const getAdviser = (p) =>
  $axios.get(`${baseUrl}/marketing/recommend/App/ownership/adviser`, p);
//查询-推荐详情
export const RecommendInfo = (p) =>
  $axios.get(`${baseUrl}/marketing/recommend/miniProgram/getRecommendInfo`, p);
//查询绑定房屋资料 我要再购
export const findPersonalData = (p) =>
  $axios.get(`${baseUrl}/customer/userroom/findPersonalData`, p);

//查询绑定房屋资料 我要再购
export const getUserList = () =>
  $axios.get(`${baseUrl}/customer/userroom/findCohabitants`);

// 微信端我要推荐获取城市项目列表

export const getCityProjList = (p) =>
  $axios.get(`${baseUrl}/customer/oDBroker/findProjById`, p);
